import Vue from 'vue'
import App from './App.vue'
import router from './router'
import JQuery from 'jquery'
import VueTippy from 'vue-tippy'
import Communicator from './communicator'
import Vuex from 'vuex'
import store from './store/store'
import VueTextareaAutosize from 'vue-textarea-autosize'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueTextareaAutosize)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBC2GSa1WxwRXqzsVJxRmJ-3pv1PrEMBlc',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.use(Vuex);

Vue.use(VueTippy)

window.$ = JQuery
window.Vue = Vue;

Vue.config.productionTip = false

new Vue({
  store: store,
  router,
  render: function (callback) { return callback(App) }
}).$mount('#app')